<template>
  <div class="content-item">
    <h2 class="heading" :class="[isError && 'error']">Email to send Proofs *</h2>
    <p class="text">
      You MUST approve them before we can ship them to you. You can expect to receive a proof in 1-3 business days to the email you have provided, after you approve the proof it will take
      approximately 2 weeks for printing and shipping.
    </p>
    <div class="form-group">
      <input v-model="proofs_email" type="text" name="textDemo" class="form-input" :class="[isError && 'error']" placeholder="example@example.com" />
    </div>
  </div>
</template>

<script>
import { empty, validateEmail } from '@/utils';
import { debounce, isFunction } from 'lodash';
export default {
  name: 'Step14',
  props: {
    value: {
      type: Object,
    },
    step: {
      type: Number,
    },
  },
  data() {
    return {
      isError: false,
      proofs_email: '',
    };
  },
  watch: {
    isError: {
      handler(value) {
        if (isFunction(this.doEmitErrorDebouned)) {
          this.doEmitErrorDebouned(value);
        } else {
          this.doEmitError(value);
        }
      },
      immediate: true,
    },
    proofs_email(value) {
      this.isError = !validateEmail(value);
    },
  },
  created() {
    this.doEmitErrorDebouned = debounce(this.doEmitError, 400);
  },
  methods: {
    submit() {
      if (empty(this.proofs_email)) {
        this.isError = true;
        this.$emit('onAnimated', [true, this.step, 'This field is required.']);
      } else {
        this.isError = false;
        this.$emit('input', {
          ...this.value,
          proofs_email: this.proofs_email,
        });
      }
    },
    doEmitError(value) {
      this.$emit('onInvalid', [value, this.step, 'This field is required.']);
    },
  },
};
</script>

.
<style lang="scss" scoped>
.content-item {
  .heading.error {
    color: #e34343;
  }

  .form-input.error {
    border: 1px solid #e34343;
  }
}
</style>
